class PopupClear {
    constructor() {
        this._init()
    }
    _init() {
        // document.querySelectorAll('.popup-clear').forEach(function (el) {
        //     el.addEventListener('click', function() {
        //         el.remove()
        //     })

        //     el.querySelectorAll('.popup-clear-action').forEach(function (elAction) {
        //         elAction.addEventListener('click', function() {
        //             el.remove()
        //         })
        //     })
        // })
        document.querySelectorAll('.popup-clear').forEach(function (el) {
            // el.addEventListener('click', function() {
            //     el.remove()
            // })

            var idx = el.dataset.idx;
            var animate = false

            if (el.classList.contains('popup--animation')) {
                animate = true
            }

            el.querySelectorAll('.popup-clear-action').forEach(function (elAction) {
                elAction.addEventListener('click', function() {
                    el.classList.add('popup--animation')
                    // if (animate) {
                        setTimeout(function() {
                            // el.remove()
                            el.style.display = 'none';
                        }, 500)
                    // }
                })
            })

            document.querySelectorAll('[data-popup-open="'+idx+'"]').forEach(function (elOpen) {
                elOpen.addEventListener('click', function(e) {
                    e.preventDefault();
                    el.style.display = '';
                    setTimeout(function() {
                        el.classList.remove('popup--animation');
                    }, 100);
                });
            })
        })
    }
}

export default PopupClear